import React from 'react';
import Link, { Props } from '../../components/Link';
import SchoolyearLink from '@teetsh/app/src/components/Link/SchoolyearLink';
import { useParams } from 'react-router-dom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import ButtonLink from 'components/Buttons/Link';
import SchoolyearButtonLink from 'components/Buttons/SchoolyearButtonLink';
import { BaseButtonProps } from 'components/Buttons/BaseButtonProps';

export function CahierJournalLink(props: Props & { readonly?: boolean }) {
  const { to, readonly, ...rest } = props;
  const user = useUser();
  const { userId, token } = useParams<{
    token: string;
    userId: string;
  }>();

  if (user.guestMode?.enabled && userId && token) {
    return <Link to={`/shares/${userId}/t/${token}/${to}`} {...rest} />;
  }
  return <SchoolyearLink to={to} readonly={readonly} {...rest} />;
}

export function CahierJournalButtonLink(
  props: BaseButtonProps & {
    to: string;
  },
) {
  const { to, ...rest } = props;
  const user = useUser();
  const { userId, token } = useParams<{
    token: string;
    userId: string;
  }>();

  if (user.guestMode?.enabled && userId && token) {
    return <ButtonLink to={`/shares/${userId}/t/${token}/${to}`} {...rest} />;
  }
  return <SchoolyearButtonLink to={to} {...rest} />;
}
